import React from 'react';
import './Contact.css';

function Contact() {  

  return (
    <>
    <div className='body'>
    <div className="contactus">
    <div className="container-fluid text-center" >

        <h2 style={{color:'#162533',fontWeight:'500',fontFamily:'fantasy',marginTop:'20px'}} >Contactez-nous</h2>
    </div>
    <div>
        <h5 className="container-fluid text-center" style={{ color: 'orange', textAlign:'center' ,fontSize: '16px' }}>
            Envoyez vos questions ou vos suggestions pour qu'on puisse rester à votre écoute.
        </h5>
    </div>


        <div className="box">
            <div className="contact form">
                <form>
                     <div className="formBox">
                        <div className="row50">
                            <div className="inputBox">
                                <span>Nom </span>
                                <input type="text" placeholder=" Votre Nom..."/>
                            </div> 
                            <div className="inputBox">
                                <span> Prénom </span>
                                <input type="text" placeholder=" Votre Prénom..."/>
                            </div> 
                        </div>

                        <div className="row50">
                            <div className="inputBox">
                                <span>Adresse Email </span>
                                <input type="text" placeholder=" Votre adresse mail..."/>
                            </div> 
                            <div className="inputBox">
                                <span>Téléphone  </span>
                                <input type="text" placeholder=" Numéro de Téléphone..."/>
                            </div> 

                        </div>
                        <div className="row50">
                            <div className="inputBox">
                                <span> Sujet </span>
                                <input type="text" />
                            </div>
                            <div className="inputBox">
                                <span> Services </span>
                                <select>
                                    <option value> services...</option>
                                    <option value="addmision">Addmission</option>
                                    <option value="autre">Autre</option>
                                </select>
                            </div>
                        </div>



                        <div className="row100">
                            <div className="inputBox">
                                <span>Message </span>
                                <textarea placeholder="Ecrire votre message"></textarea>
                            </div>
                        </div>

                        <div className="row100">
                            <div className="inputBox">
                            <div className="row100">
                        <div className="inputBox">
                          <button type="submit" className="submit-button">
                            Envoyer <div style={{marginLeft:'8px',marginTop:'7px'}}><ion-icon name="send-outline" className="send-icon"></ion-icon></div>
                          </button>
                        </div>
                      </div>

                            </div>
                        </div>

                     </div>
                </form>
            </div>
            <div className="contact info">
                <h3>Contact info </h3>
                <br/>
                <div className="infoBox">
                    <div>
                       <span><ion-icon name="location"></ion-icon></span>
                       <p>Avenue de la Corniche, <br/>Monastir 5000 ,Tunisie</p>
                    </div>
                    <div >
                        <span><ion-icon name="mail"></ion-icon></span>
                        <a href="mailto:isimm@isimm.u-monastir.tn" style={{ color: '#162533' }} >isimm@isimm.u-monastir.tn</a>
                    </div>
                    <br/>
                    <div>
                        <span><ion-icon name="call"></ion-icon></span>
                        <a href="tel:24758444"style={{ color: '#162533' }}> TEL : +216 70 011 920 <br/>FAX : +216 70 011 959</a>
                    </div>
                </div>
            </div>


            <div className="contact map">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3237.441654484694!2d10.840147!3d35.764526!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212d6df016097%3A0x528cc1e524eece77!2sHigher%20Institute%20of%20Informatics%20and%20Mathematics%20of%20Monastir!5e0!3m2!1sen!2sus!4v1705868469563!5m2!1sen!2sus"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            
            </div>

            
        </div>
    </div>
    </div>
    </>
  );
};

export default Contact;